import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSignInContext } from './SignInContext';
import { Button } from '../../components/UI';
import { FormikProvider, useFormik } from 'formik';
import { useMutation } from '@apollo/client';
import { COMPLETE_TOTP_BYPASS } from '../../http/apollo-queries';
import { InputCode } from '../../components/form';
import { Modal } from '../../components/Modal';

const SignInBypass2FA = () => {
  const { t } = useTranslation();

  const [completeTOTPBypass, { loading: completeTOTPBypassLoading }] =
    useMutation(COMPLETE_TOTP_BYPASS);

  const [error, setError] = useState('');

  const { state, dispatch } = useSignInContext();

  const formik = useFormik({
    initialValues: {
      email: state.cognitoUser?.attributes?.email,
      masterKey: '',
      code: '',
    },
    validateOnBlur: false,
    validateOnChange: false,
    validateOnMount: true,
    onSubmit: (values) => {
      setError('');
      completeTOTPBypass({
        variables: {
          code: values.code,
          bypassToken: state.token2fa,
        },
      })
        .then(({ data: { completeTOTPBypass } }) => {
          if (completeTOTPBypass.status === 'FAILED') {
            setError('Bypass failed');
          } else if (completeTOTPBypass.status === 'SUCCESS') {
            dispatch({
              type: 'SET_STEP',
              payload: 'LOGIN',
            });
          }
        })
        .catch((error) => {
          setError(error.message);
        });
    },
  });

  return (
    <Modal
      isOpen={true}
      backdrop={'solid'}
      handleMerlinLogo={true}
      isClosable={false}
      padding={'huge'}
    >
      <div className={'text-center'}>
        <h1 className={'text-black text-xl font-semibold mb-4 dark:text-white'}>
          {t('bypass2fa.title')}
        </h1>
        <p className={'text-grey-50 text-sm whitespace-pre-wrap'}>
          {t('bypass2fa.subtitle')}
        </p>
        <FormikProvider value={formik}>
          <form onSubmit={formik.handleSubmit}>
            <div className="mt-12">
              <InputCode
                name="code"
                id="code"
                numberOfDigits={6}
                formik={formik}
                label={t('bypass2fa.form.label.code')}
                errorMessage={error}
              />
            </div>
            <div className="mt-10">
              <Button
                type="submit"
                variant="primary"
                buttonClass="w-64"
                loading={completeTOTPBypassLoading}
              >
                {t('bypass2fa.form.label.submit')}
              </Button>
            </div>
          </form>
        </FormikProvider>
      </div>
    </Modal>
  );
};

export default SignInBypass2FA;
